import { Form } from "antd";
import { useEffect } from "react";
import { rules } from "../../../siteData/rules";
import CustomDropdown from "../../../component/CustomDropdown";
import FilledButton from "../../../component/FilledButton";

const AddThoughtLeader = ({ btnLoader, handleAddThoughtLeader, category, handleChange, categoryData, handleModalClose, setFormRef }) => {
    const [form] = Form.useForm();
    form.setFieldsValue(categoryData);

    useEffect(() => {
        setFormRef(form);
    }, []);

    return (
        <div className="modal_body">
            <div className="add_thought_leader">
                <Form
                    form={form}
                    name="register"
                    onFinish={(e) => handleAddThoughtLeader(e, form)}
                    onReset={handleModalClose}
                    scrollToFirstError
                    className="attached_courses-add_skill"
                >
                    <h2>add thought leader</h2>
                    <Form.Item name="email" rules={rules.email} className="form_group">
                        <label>Email *</label>
                        <input type="email" name='email' onChange={handleChange} className="form_control" />
                    </Form.Item>
                    <Form.Item name="first_name" className="form_group">
                        <label>First Name</label>
                        <input type="text" name='first_name' onChange={handleChange} className="form_control" />
                    </Form.Item>
                    <Form.Item name="last_name" className="form_group">
                        <label>Last Name</label>
                        <input type="text" name='last_name' onChange={handleChange} className="form_control" />
                    </Form.Item>

                    <CustomDropdown
                        options={category}
                        name="skill_name"
                        forlabel='Skills'
                        value={categoryData.skill_name}
                        onChange={handleChange}
                        showSearch
                    />
                    <div class="form_group form_footer d_flex_center">
                        <button type="reset" className="btn btn_gray">cancel</button>
                        <FilledButton type="submit" loading={btnLoader} value={"invite"} className="btn btn_primary" />
                    </div>
                </Form>
            </div>
        </div>
    )
};

export default AddThoughtLeader;